<template>
	<div class="filterSlider">
        <vue-slider v-model="range" v-on:change="changeRange" 
        :enable-cross="false" :min="getProperty(layer, idProp).min" :max="getProperty(layer, idProp).max" :tooltip="'always'"
        :interval="getInterval(getProperty(layer, idProp))">
            <template v-slot:tooltip="{ value, focus }">
                <div :class="['custom_tooltip', { focus }]">
                    <span>{{ getValue(value) }}</span>
                </div>
            </template>
        </vue-slider>

	</div>
</template>

<script>
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/default.css'

export default {
	name: 'FilterSlider',
	components: {
		VueSlider
	},
	props: {
        okanMap : Object,
        layer : Object,
        idProp: Number
	},
	data: function() {
		return {
            range : [this.getProperty(this.layer, this.idProp).filter.min, this.getProperty(this.layer, this.idProp).filter.max],
            interval : 1

		}
	},
	mounted() {
        /*
        if(this.layer.name == 'Events') {
            console.log(this.getProperty(this.layer, this.idProp))
        }
        */
	},
	created() {

	},
	destroyed() {

	},
	methods : {

		init() {
        },

        getInterval(properties) {

            if(properties.min != null && properties.max != null) {
                if(!Number.isInteger(properties.min) || !Number.isInteger(properties.max))
                    return 0.01;
                else if(Math.abs(properties.max - properties.min) <= 5 )
                    return 0.01;
            }
            
            return 1.0;

        },

        changeRange(range) {
            var newMin = range[0];
            var newMax = range[1];
            this.$emit('FilterUpdate', {
                layer: this.layer,
                min: newMin,
                max: newMax,
                indexProperty: this.idProp
            })
        },

        getSource(layer) {
			return this.okanMap.sources[this.layer.sourceIndex]
		},

		getProperty(layer, indexProperty) {
			return this.getSource(this.layer).properties[this.idProp];
		},

        getValue(value) {

            if(this.getProperty(this.layer, this.idProp).type == 'date')
                return this.valueToDate(value)
            else
                return value

        },
        
        valueToDate(value){
            return this.dateToString(new Date(value));
        },
        dateToString(d){

            var minutes = d.getMinutes().toString().length == 1 ? '0'+d.getMinutes() : d.getMinutes();
            var hours = d.getHours().toString().length == 1 ? '0'+d.getHours() : d.getHours();
            var days = d.getDate().toString().length == 1 ? '0'+ d.getDate() : d.getDate();
            var month = d.getMonth() + 1;
            var months = month.toString().length == 1 ? '0'+ month : month;
            var hoursminutes = hours+':'+minutes;

            hoursminutes = ''

            return days + '/' + months +'/'+ d.getFullYear() +''+hoursminutes;
        }

	}
}
</script>

<style scoped src="../../assets/css/ui.css"></style>